export default "__VITE_ASSET__bd097c02__"